//Routes
import routing from "./account.routes";

//Controllers
import LoginController from "./controllers/login.controller";
import RegistrationController from "./controllers/registration.controller";
import VerificationController from "./controllers/verification.controller";
import TokenController from "./controllers/token.controller";
import AccountModalController from "./controllers/modals/account.modal.controller";

//Services
import RegistrationService from "services/registration.service";
import AuthenticateService from "services/authenticate.service";

//Add to Angular
export default angular.module("hmrx.app.account", [AuthenticateService, RegistrationService])
  .config(routing)
  //Add all controllers
  .controller("LoginController", LoginController)
  .controller("RegistrationController", RegistrationController)
  .controller("VerificationController", VerificationController)
  .controller("TokenController", TokenController)
  .controller("AccountModalController", AccountModalController)
  .name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/features/account/index.js
 **/